import React from 'react'
import { Store } from './redux/Store'
import { Provider } from 'react-redux'
import { useRoutes } from 'react-router-dom'
import AppContext from './contexts/AppContext'
import { AuthProvider } from './contexts/JWTAuthContext'
import { SettingsProvider } from './contexts/SettingsContext'
import { MatxTheme } from './components'
import { AllPages } from './routes/routes'

const App = () => {
    const all_pages = useRoutes(AllPages())

    return (
        <AppContext.Provider>
            <Provider store={Store}>
                <SettingsProvider>
                    <MatxTheme>
                        <AuthProvider>{all_pages}</AuthProvider>
                    </MatxTheme>
                </SettingsProvider>
            </Provider>
        </AppContext.Provider>
    )
}

export default App
